import { useQuery } from '@tanstack/react-query';

import { CabinEventClient } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const cabinEventClient = new CabinEventClient(apiBaseUrl);

function useGetCabinEventDrafts() {
  return useQuery({
    queryKey: [queryKeys.CabinEvent.Drafts],
    queryFn: () => cabinEventClient.getDrafts(),
  });
}

export default useGetCabinEventDrafts;
